import React from 'react';
import I18N from '@leverege/i18n';
import MapViewer from "./MapView.js";
import DataViewerModelUpdaterCreator from "../../DataViewerModelUpdaterCreator.js";
import MapViewerModel from "../shared/models/MapViewerModel.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.map.MapDataViewer');
export default {
  id: 'molten.dataViewers.map.MapDataViewer',
  type: 'molten.Map',
  name: tf('name'),
  icon: tfIcon('configIcon'),
  layout: {
    section: tf('section'),
    sort: 'a.a'
  },
  location: ['main', 'card'],
  matches: {
    type: ['GroupDataViewer', 'ItemInfoDataViewer']
  },
  createSettings: props => {
    return MapViewerModel.create();
  },
  settingsUpdaters: DataViewerModelUpdaterCreator.create('MapViewModelUpdater'),
  render: props => {
    const {
      delegate,
      dataViewers
    } = props;
    if (dataViewers.areOfType('ItemInfoDataViewer')) {
      return /*#__PURE__*/React.createElement(MapViewer, {
        ...props,
        delegate: delegate.parent()
      });
    }
    return /*#__PURE__*/React.createElement(MapViewer, props);
  },
  getDefaultCardContentOptions: {
    height: '300px'
  },
  getDefaultCardOptions: {
    width: 1
  }
};